import './loading.css';

type Variant = 'results' | 'preferences' | 'sessions' | 'participants' | 'field';
export function Skeleton({className = ''}: {className?: string}) {
    return <div aria-hidden="true" className={`fw-skeleton rounded-xl ${className}`}/>;
}

function Card({ticket = false}: {ticket?: boolean}) {
    return <div className="space-y-4 rounded-2xl border border-white/80 bg-white/70 p-5">
        <Skeleton className="h-3 w-24"/><Skeleton className="h-7 w-2/3"/>
        <Skeleton className="h-3 w-4/5"/>
        {ticket && <div className="grid grid-cols-2 gap-4 pt-3"><Skeleton className="h-16"/><Skeleton className="h-16"/></div>}
        <Skeleton className="h-8 w-32"/>
    </div>;
}

export default function GroupSkeleton({variant, label}: {variant: Variant; label: string}) {
    return <div role="status" aria-label={label} className={`fw-loading ${variant === 'sessions' ? 'fw-session-loading' : ''}`}>
        <span className="sr-only">{label}</span>
        <div aria-hidden="true">
            {variant === 'results' && <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
                <div className="flex gap-3 overflow-hidden lg:flex-col">{[0, 1, 2].map(i => <div key={i} className="min-w-[220px]"><Card/></div>)}</div>
                <div className="space-y-6 rounded-3xl bg-white/60 p-5 sm:p-7">
                    <Skeleton className="h-6 w-48"/><Skeleton className="h-9 w-2/3"/><Skeleton className="h-4 w-4/5"/>
                    <Card ticket/><Card ticket/>
                </div>
            </div>}
            {variant === 'preferences' && <div className="grid gap-6 md:grid-cols-2">
                {[0, 1, 2, 3].map(i => <div key={i} className={`space-y-5 rounded-3xl bg-white/70 p-6 ${i === 0 || i === 3 ? 'md:col-span-2' : ''}`}>
                    <Skeleton className="h-6 w-40"/><Skeleton className="h-12"/><Skeleton className="h-12"/>
                </div>)}
            </div>}
            {variant === 'sessions' && <div className="flex overflow-hidden"><div className="flex h-[290px] w-[250px] shrink-0 flex-col rounded-[28px] border border-white bg-white/60 p-6">
                <Skeleton className="h-11 w-28 rounded-full"/><Skeleton className="mt-6 h-7 w-4/5"/><Skeleton className="mt-auto h-12 rounded-full"/>
            </div></div>}
            {variant === 'participants' && <div className="space-y-6 py-3">{[0, 1].map(i => <div key={i} className="space-y-3">
                <Skeleton className="h-4 w-40"/><div className="flex flex-wrap gap-3">{[0, 1, 2].map(j => <div key={j} className="flex items-center gap-3 rounded-full bg-white/60 p-3">
                    <Skeleton className="h-8 w-8 rounded-full"/><Skeleton className="h-3 w-20"/>
                </div>)}</div>
            </div>)}</div>}
            {variant === 'field' && <Skeleton className="h-8 w-full"/>}
        </div>
    </div>;
}

export function PageSkeleton() {
    return <main className="min-h-screen bg-gradient-to-b from-[#f6f8ff] to-[#dde5ff] px-6 py-12">
        <div className="fw-auth-placeholder mx-auto max-w-6xl">
            <div aria-hidden="true" className="mb-12 space-y-5"><Skeleton className="h-8 w-28"/><Skeleton className="mt-16 h-12 w-2/3"/><Skeleton className="h-4 w-1/2"/></div>
            <GroupSkeleton variant="sessions" label="Deine Reisen werden geladen"/>
        </div>
    </main>;
}
